// removed by extract-text-webpack-plugin
module.exports = {"fullScreenPropertiesList":"ZaUO7-0MdPk9E9LVNSaIz","spinner":"iKBYaivk182Ofld9fJJt6","spinnerPosition":"_1xSu_6UQQFexbbdkkDIRkt"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/FullScreenPropertiesList/FullScreenPropertiesList.scss
// module id = 1836
// module chunks = 0